import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JobLocation } from '../locations/locations.service';


export class SalaryType {

  static get RANGE(): string {
    return '%R&';
  }
  static get NEGOTIABLE(): string {
    return '$N!';
  }
  static get FIXED(): string {
    return '$F*';
  }
  static get MARKET(): string {
    return '!M&';
  }
  static get HIDE(): string {
    return '!h&';
  }
  static toCurrency(value: number) {
    if (isNaN(value)) {
      return value.toString();
    }
    value = Number(value.toString());
    return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(value);
  }
}



export class Salary {
  type: string;
  value: number;
  from: number;
  to: number;
  constructor() {
    this.type = SalaryType.HIDE;
    this.value = 0;
    this.from = 0;
    this.to = 0;
  }
}
export class Job {
  id: number;
  title: string;
  location: JobLocation;
  description: string;
  contract: string;
  salary: Salary;
  requirements: string[];
  duties: string[];
  education: string[];
  skills: string[];
  created: Date;
  modified: Date;
  constructor() {
    this.id = 0;
    this.title = '';
    this.location = new JobLocation();
    this.description = '';
    this.contract = '';
    this.salary = new Salary();
    this.requirements = [];
    this.duties = [];
    this.education = [];
    this.skills = [];
    this.created = new Date();
    this.modified = new Date();
  }
}
@Injectable({
  providedIn: 'root'
})
export class JobsService {
  private httpRequest: Observable<Job[]>;
  private Jobs: Job[];
  get jobs(): Job[] {
    if (this.Jobs === undefined || this.Jobs === null) {
      this.Jobs = [];
      this.load();
    }
    return this.Jobs;
  }
  constructor(private http: HttpClient) { }
  load() {
    this.update();
  }
  update() {
    this.httpRequest = this.http.get<Job[]>('assets/data/jobs.json');
    this.httpRequest.subscribe(response => {
      this.jobs.splice(0, this.jobs.length);
      for (const job of response) {
        this.Jobs.push(job);
      }
    });
  }

  async getJob(jobId: number): Promise<Job> {
    if (this.Jobs !== undefined && this.Jobs !== null) {
      for (const job of this.jobs) {
        if (job.id === jobId) {
          return job;
        }
      }
    }
    this.update();
    await this.httpRequest.toPromise();
    for (const job of this.jobs) {
      if (job.id === jobId) {
        return job;
      }
    }
    return undefined;
  }

}
